export { HeaderComponent } from './header.component';
export { HeaderModule } from './header.module';

export * from './full-screen'
export * from './collapse-menu'
export * from './recent-projects'
export * from './activities'



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/index.ts